export enum USER_STATUS {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum TYPE_EMPLOYMENT {
  FULL_TIME_JOB = "Full-Time Job",
  PART_TIME_JOB = "Part-Time Job",
}

export enum SURVEY_STATUS {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum USER_SURVEY_STATUS {
  NEW = "New",
  IN_PROGRESS = "In progress",
  COMPLETED = "Completed",
}

export enum USER_ONBOARDING_STATUS {
  NEW = "New",
  IN_PROGRESS = "In progress",
  COMPLETED = "Completed",
}

export enum USER_ONBOARDING_STEP_STATUS {
  NEW = "New",
  IN_PROGRESS = "In progress",
  COMPLETED = "Completed",
}

export enum USER_PROCEDURE_STATUS {
  NEW = "New",
  IN_PROGRESS = "In progress",
  REVIEWED = "Reviewed",
}

export enum GOALS_STATUS {
  IN_PROGRESS = "In progress",
  COMPLETED = "Completed",
  CLOSED = "Closed",
}

export enum PROJECT_STATUS {
  ACTIVE = "Active",
  COMPLETED = "Completed",
}

export enum RECOGNITION_STATUS {
  APPROVED = "Approved",
  DECLINED = "Declined",
  REVIEW = "Review",
}

// Mirrors api/app/shared/constants/recognitionFlag.ts EXACTLY, including the enum names — that file's
// own header warns renaming/removing a member is a data migration, not a refactor, because these
// values are simultaneously `recognition_flags.flag_type` / `.severity` and HR-facing pill text.
// Title Case (not lowercase) per pavel's 2026-08-06 decision, recorded in that same api file and
// applied by migration 20260806110100. Six flag types, not five — Thin Note and Duplicate Note are
// deliberately kept separate.
export enum RECOGNITION_FLAG_TYPE {
  RECIPROCITY = "Reciprocity",
  PAIR_CONCENTRATION = "Pair Concentration",
  THIN_NOTE = "Thin Note",
  DUPLICATE_NOTE = "Duplicate Note",
  LOW_SPREAD = "Low Spread",
  VELOCITY_SPIKE = "Velocity Spike",
}

export enum RECOGNITION_FLAG_SEVERITY {
  LOW = "Low",
  MEDIUM = "Medium",
  HIGH = "High",
}

// Mirrors api/app/shared/constants/recognitionBulkApprove.ts EXACTLY, including the enum name — this
// is the element type of POST /recognitions/bulk-approve's response `skipped[].reason`, so a member
// rename/removal is a breaking wire change, not a refactor. Same reasoning as RECOGNITION_FLAG_TYPE/
// RECOGNITION_FLAG_SEVERITY above.
export enum BULK_APPROVE_SKIP_REASON {
  FLAGGED = "flagged",
  NOT_IN_REVIEW = "not_in_review",
  NOT_FOUND = "not_found",
}
